import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { supabase } from '../lib/supabase';
import { BrandMark } from '../components/BrandMark';
import { ConsentBanner } from '../components/ConsentBanner';
import { startAnalytics, pageview } from '../lib/analytics';

interface Row {
  slug: string; name: string; cuisine_category: string | null; city: string | null;
  public_tags: string[]; public_description: string | null;
}

export function PublicCityPage() {
  const { country, state, city } = useParams();
  const { i18n } = useTranslation();
  const [rows, setRows] = useState<Row[]>([]);
  const [cityName, setCityName] = useState('');

  useEffect(() => {
    void (async () => {
      const { data } = await supabase.from('restaurants')
        .select('slug, name, cuisine_category, city, public_tags, public_description')
        .eq('country_slug', country).eq('state_slug', state).eq('city_slug', city).eq('public_published', true)
        .order('name');
      if (data) {
        setRows(data as Row[]);
        setCityName((data[0]?.city as string) ?? (city ?? ''));
      }
    })();
  }, [country, state, city]);

  const tt = i18n.getFixedT('pt-BR');
  useEffect(() => {
    document.title = `${tt('pub.menu')} · ${cityName} | La petite table`;
    startAnalytics();
    pageview(window.location.pathname, document.title);
  }, [cityName]);

  return (
    <div className="pub-page">
      <header className="pub-hero">
        <h1 className="pub-hero__name">{cityName}</h1>
        <p className="pub-hero__meta">{rows.length} {rows.length === 1 ? 'restaurante' : 'restaurantes'}</p>
      </header>
      <section className="pub-list">
        {rows.map((r) => (
          <Link key={r.slug} className="pub-list__item" to={`/${country}/${state}/${city}/${r.slug}`}>
            <strong>{r.name}</strong>
            {r.cuisine_category && <span className="pub-list__cuisine"> · {r.cuisine_category}</span>}
            {r.public_description && <p className="pub-list__desc">{r.public_description.slice(0, 140)}</p>}
            {r.public_tags.length > 0 && (
              <div className="pub-tags">{r.public_tags.map((tag) => <span key={tag} className="pub-tag">{tt(`pub.tag_${tag}`)}</span>)}</div>
            )}
          </Link>
        ))}
        {rows.length === 0 && <p className="center-note">{tt('pub.not_found')}</p>}
      </section>
      <footer className="pub-footer">
        <span className="pub-footer__brand"><BrandMark className="brand__mark" /> La petite table</span>
      </footer>
      <ConsentBanner />
    </div>
  );
}
